import {
  Box,
  Flex,
  Icon,
  Space,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { AngleRightIcon } from '@tonic-one/react-icons';
import { useEffect } from 'react';
import SmartTooltip from 'src/pages/Report/SmartTooltip';
import { useTranslation } from 'react-i18next';
import { IS_UAE } from '@Utils/const';
import { useLicenseStore } from '@Models/useLicenseModel';
import { GlobalApi } from '@Apis';
import { useBreadCrumbStore } from '@Models/useBreadCrumbModel';
import { useWhiteLabelStore } from '@Models/useWhiteLabelModel';

function BreadCrumb() {
  const whiteLabelModel = useWhiteLabelStore();
  const { license } = useLicenseStore();

  useEffect(() => {
    async function fetchData() {
      if (
        license &&
        license.tenantId &&
        license.tenantId.toLowerCase() !== 'tm'
      ) {
        const whiteLabelResp = await GlobalApi.getWhiteLabel(
          license.tenantId.toLowerCase()
        );
        if (whiteLabelResp.data) {
          const newWhiteLabel = 'data:image/png;base64,' + whiteLabelResp.data;
          whiteLabelModel.setWhiteLabel(newWhiteLabel);
        }
      }
    }

    fetchData();
  }, [license, whiteLabelModel]);

  return <BreadCrumbContent whiteLabel={whiteLabelModel.whiteLabel} />;
}

function BreadCrumbContent({ whiteLabel }: { whiteLabel: string }) {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const breadCrumbModal = useBreadCrumbStore();
  let productBanner = (
    <Box
      fontSize="24px"
      lineHeight="32px"
      dangerouslySetInnerHTML={{
        __html: t('common.productName'),
      }}
    />
  );
  if (IS_UAE) {
    productBanner = (
      <Box>
        <Text fontSize="24px" lineHeight="32px" fontWeight="300">
          Cyber Eye Cloud Service Security
          <sup style={{ marginLeft: '6px' }}>Powered by Trend Micro</sup>
        </Text>
      </Box>
    );
  } else if (whiteLabel) {
    productBanner = <img src={whiteLabel} />;
  }
  return (
    <Flex align="center" color={colorStyle.color.emphasis}>
      {productBanner}
      <Box
        borderLeft="solid 2px"
        borderColor="#424242"
        height="16px"
        width="0px"
        margin="0 12px"
      />
      <Box>
        {breadCrumbModal.breadCrumb.length > 0 && (
          <Text fontSize="14px" opacity="0.9" maxWidth={320}>
            <Flex flexDirection="row">
              <Box style={{ whiteSpace: 'nowrap' }}>
                <Space
                  color={colorMode === 'dark' ? colorStyle.color.secondary : ''}
                >
                  {breadCrumbModal.breadCrumb[0].breadCrumb}
                </Space>
              </Box>
              {breadCrumbModal.breadCrumb.length > 1 && (
                <>
                  <Box>
                    <Icon
                      as={AngleRightIcon}
                      color={
                        colorMode === 'dark' ? colorStyle.color.secondary : ''
                      }
                    />
                  </Box>
                  <Box>
                    <SmartTooltip>
                      {breadCrumbModal.breadCrumb[1].breadCrumb}
                    </SmartTooltip>
                  </Box>
                </>
              )}
            </Flex>
          </Text>
        )}
      </Box>
    </Flex>
  );
}

export default BreadCrumb;
